import { render, staticRenderFns } from "./CourseDaySetZoomID.vue?vue&type=template&id=12ca8d1f&lang=pug&"
import script from "./CourseDaySetZoomID.vue?vue&type=script&lang=js&"
export * from "./CourseDaySetZoomID.vue?vue&type=script&lang=js&"
import style0 from "./CourseDaySetZoomID.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
